<section class="sk-cms-nav-wap {{basic.style.type}}"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
  {{each content.items}}
                  {{if $value.isShowTitle && $value.isShowTitle != 'false' && $value.isShowTitle != '0'  && $index<4}}
                    {{if isDesign}}
                    <div class="nav-bottom-item" sk-class="{{$value.href && $value.href.pageId?$value.href.pageId:'-1'}} == $data.pid? 'active' : ''">
                      <div class="icon" >
                         <img class="icon-default" src="{{$value.icon ? $value.icon : '../../assets/images/nav-icon.png'}}" cms-smarket alt=""/>
                         <img class="icon-active" src="{{$value.iconActive ? $value.iconActive : '../../assets/images/nav-icon-active.png'}}" cms-smarket alt=""/>
                      </div>
                      <div class="title {{style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}}"

                        {{if style.menu1.styleType == 'custom'}}
                          style="color: {{style.menu1.color}}"
                        {{/if}}
                      >
                        {{$value.title}}
                      </div>
                    </div>
                    {{else}}
                                          <div class="nav-bottom-item" sk-class="{{$value.href && $value.href.pageId?$value.href.pageId:'-1'}} == $data.pid? 'active' : ''">
                                          {{if $value.type == 2 || $value.type == 3 || $value.type == 4 || $value.type == 6 || $value.type == 7 || ($value.type == 100 && ($value.linkType == 'custom' && $value.link || $value.linkType == 'system' && $value.href.url))}}
                                            <a href="{{$value.link}}" target="_self">
                                            <div class="icon" >
                                               <img class="icon-default" src="{{$value.icon ? $value.icon : '../../assets/images/nav-icon.png'}}" cms-smarket alt=""/>
                                               <img class="icon-active" src="{{$value.iconActive ? $value.iconActive : '../../assets/images/nav-icon-active.png'}}" cms-smarket alt=""/>
                                            </div>
                                            <div class="title {{style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}}"

                                              {{if style.menu1.styleType == 'custom'}}
                                                style="color: {{style.menu1.color}}"
                                              {{/if}}
                                            >
                                              {{$value.title}}
                                               </a>
                                            </div>
                                          {{else}}
                                                                                        <div class="icon" >
                                                                                           <img class="icon-default" src="{{$value.icon? $value.icon : '../../assets/images/nav-icon.png'}}" cms-smarket alt=""/>
                                                                                           <img class="icon-active" src="{{$value.iconActive?$value.iconActive : '../../assets/images/nav-icon-active.png'}}" cms-smarket alt=""/>
                                                                                        </div>
                                                                                        <div class="title {{style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}}"

                                                                                          {{if style.menu1.styleType == 'custom'}}
                                                                                            style="color: {{style.menu1.color}}"
                                                                                          {{/if}}
                                                                                        >
                                                                                          {{$value.title}}
                                                                                        </div>
                                          {{/if}}
                                          </div>
                    {{/if}}
                  {{/if}}
    {{/each}}
    <div class="nav-logo">
        {{if style.isShowLogo == '1' && content.logo}}
        <img src="{{content.logo}}" alt="logo">
        {{/if}}
    </div>

    <div class="nav-menu" sk-event.click="show()"></div>

    <aside class="sk-nav-window" sk-style="{width: $data.isShow ? '100%' : 0, height: $data.isShow ? '100%' : 0}" sk-class="$data.isActive ? 'active' : ''" cms-not-replace>
        <div class="nd-bg" sk-event.click="show()"></div>
        <div class="nd-close" sk-event.click="show()">
            <div class="close-icon"></div>
        </div>
        <nav class="nd-nav">
            <ul class="nd-list">
                {{each content.items}}
                {{if $value.isShowTitle && $value.isShowTitle != 'false' && $value.isShowTitle != '0'}}
                <li class="nd-item {{style.menu1.styleType == 'custom' ? style.menu1.fontSize : ''}}"
                    {{if style.menu1.styleType == 'custom'}}
                    style="color: {{style.menu1.color}}"
                    {{/if}}
                >
                    <div class="nd-text">
                    {{if isDesign}}
                        {{$value.title}}
                    {{else}}
                        {{if $value.type == 2 || $value.type == 3 || $value.type == 4 || $value.type == 6 || $value.type == 7 || ($value.type == 100 && ($value.linkType == 'custom' && $value.link || $value.linkType == 'system' && $value.href.url))}}
                            <a class="goto-link" href="{{$value.link}}" {{$value.linkType == 'custom' ? 'target="_blank"' : ''}}>
                            {{$value.title}}
                            </a>
                        {{else}}
                            {{$value.title}}
                        {{/if}}
                    {{/if}}
                    {{if $value.subItems && $value.subItems.length}}
                        <div class="item-icon" sk-event.click="active({{$index}})"
                            {{if style.menu1.styleType == 'custom'}}
                            style="border-color: {{style.menu1.color}}"
                            {{/if}}>
                        </div>
                    {{/if}}
                    </div>
                    {{if $value.subItems && $value.subItems.length}}
                        <ul class="nd-list-child">
                            {{each $value.subItems $value2 $index2}}
                            {{if $value2.isShowTitle && $value2.isShowTitle != 'false' && $value2.isShowTitle != '0'}}
                            <li class="nd-item {{style.menu2.styleType == 'custom' ? style.menu2.fontSize : ''}}"
                                {{if style.menu2.styleType == 'custom'}}
                                style="color: {{style.menu2.color}}"
                                {{/if}}
                            >
                                <div class="nd-text">
                                {{if isDesign}}
                                    {{$value2.title}}
                                {{else}}
                                    {{if $value2.type == 2 || $value2.type == 3 || $value2.type == 4 || $value2.type == 6 || $value2.type == 7 || ($value2.type == 100 && ($value2.linkType == 'custom' && $value2.link || $value2.linkType == 'system' && $value2.href.url))}}
                                        <a class="goto-link" href="{{$value2.link}}" {{$value2.linkType == 'custom' ? 'target="_blank"' : ''}}>
                                        {{$value2.title}}
                                        </a>
                                    {{else}}
                                        {{$value2.title}}
                                    {{/if}}
                                {{/if}}
                                </div>
                            </li>
                            {{/if}}
                            {{/each}}
                        </ul>
                    {{/if}}
                </li>
                {{/if}}
                {{/each}}
            </ul>
        </nav>
    </aside>
</section>
